import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { FaFacebookF, FaMoon, FaSun, FaInstagram, FaLinkedin, FaTwitter, FaGithubSquare, FaFileAlt } from 'react-icons/fa'
import { Redirect, useParams } from "react-router-dom";
import firebase from '../../firestore'
import Loading from '../../components/Loading'
import User from '../../assets/User.jpg'
// import { Planets } from 'react-preloaders'
const GenHeader = () => {
    // Darkmode
    const [darkmode, setDarkMode] = useState(getInitialMode())
    const [userDetails, setUserDetails] = useState()
    let { username } = useParams();

    useEffect(() => {
        localStorage.setItem("dark", JSON.stringify(darkmode));
    }, [darkmode])

    function getInitialMode() {
        const isReturningUser = "dark" in localStorage;
        const savedMode = JSON.parse(localStorage.getItem("dark"));
        const userPrefersDark = getPrefColorScheme();
        if (isReturningUser) {
            return savedMode;
        }
        else if (userPrefersDark) {
            return true;
        }
        else {
            return false;
        }
    }

    function getPrefColorScheme() {
        if (!window.matchMedia) return;
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }

    useEffect(() => {
        firebase.database().ref('/users/' + username).once('value', (snapshot) => {
            if (snapshot.val() !== null) {
                setUserDetails(snapshot.val())
                // console.log('found')
            }
            else {
                setUserDetails('nouser')
            }
        })
    }, [])

    if (!userDetails) {
        // return (<Planets customLoading={true} time={0} color={'#DEEAF8'} background="#253044" />)
        // return <h1 className="loadingHeading">Loading</h1>
        return <Loading />
    }

    if (userDetails === 'nouser') {
        return (<Redirect to="/nopage" />)
    }

    document.title = "Fresume - " + userDetails.name;


    return (
        <div className={darkmode ? "DARKMODE" : null}>
            <div className="generatedContainer">
                <Container fluid>

                    <section className="intro">
                        <Row>
                            <Col lg={5} md={12} sm={12} xs={12}>
                                <div className="LeftPanelGen">
                                    <h3>{userDetails.name}</h3>
                                    <h6>- {userDetails.tagline}</h6>
                                    <h4>Here is what to expect</h4>
                                    <p>
                                        {userDetails.about}
                                    </p>
                                    <div className="DarkModeSwitchBox">
                                        <span style={{ color: darkmode ? "grey" : "yellow" }}><FaSun /></span>
                                        <span className="toggle">
                                            <input
                                                checked={darkmode}
                                                onChange={() => setDarkMode(prevMode => !prevMode)}
                                                id="checkbox"
                                                className="checkbox"
                                                type="checkbox"
                                            />
                                            <label htmlFor="checkbox" />
                                        </span>
                                        <span style={{ color: darkmode ? "slateblue" : "grey" }}><FaMoon /></span>
                                    </div>


                                </div>
                            </Col>
                            <Col lg={7} md={12} sm={12} xs={12}>
                                <div className="RightPanelGen">
                                    <div className="imgContainer">
                                        <img src={userDetails.image ? userDetails.image : User} alt=" Fresume User image" />


                                    </div>
                                    <div className="SocialMediaCont">
                                        <div className="containerIcons">
                                            {userDetails.facebook ?
                                                <a href={userDetails.facebook} className="indivIcons" target="_blank" rel="noreferrer noopener"><FaFacebookF /></a>
                                                : null}
                                            {userDetails.instagram ?
                                                <a href={userDetails.instagram} className="indivIcons" target="_blank" rel="noreferrer noopener"><FaInstagram /></a>
                                                : null}
                                            {userDetails.linkedin ?
                                                <a href={userDetails.linkedin} className="indivIcons" target="_blank" rel="noreferrer noopener"><FaLinkedin /></a>
                                                : null}
                                            {userDetails.twitter ?
                                                <a href={userDetails.twitter} className="indivIcons" target="_blank" rel="noreferrer noopener"><FaTwitter /></a>
                                                : null}
                                            {userDetails.github ?
                                                <a href={userDetails.github} className="indivIcons" target="_blank" rel="noreferrer noopener"><FaGithubSquare /></a>
                                                : null}
                                        </div>
                                    </div>
                                    <div className={userDetails.resume ? "BtnContainer" : "noDisplay"}>
                                        <a href={userDetails.resume} target="_blank" rel="noreferrer noopener" className="btn btn-lg btn-primary BTN CVBTN">Get my CV</a>
                                    </div>
                                    <div className="BtnContainer">
                                        <a href={`mailto:${userDetails.email}`} className="btn btn-lg btn-primary BTN emailBTN">Drop me an email</a>
                                        {/* <Button variant="primary" className="BTN emailBTN" size="lg">Drop me an email</Button> */}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </section>
                    <section className="others">
                        <Row>
                            <Col lg={5} md={12} sm={12} xs={12}>
                                <div className="LeftPanelOthers">

                                    <div className="tabsOthers">
                                        <h3>Education</h3>
                                        <ul className="complicatedDiv">
                                            <li className="absoluteContainer">
                                                <h5>College</h5>
                                                <h6>{userDetails.education.grad.instName}</h6>
                                                <p>{userDetails.education.grad.progname}</p>
                                                <p>{userDetails.education.grad.univ}</p>
                                                <p>{userDetails.education.grad.state}</p>
                                                <p>Graduation Year: {userDetails.education.grad.yop}</p>
                                            </li>
                                            <li className="absoluteContainer">
                                                <h5>HSSC/Diploma</h5>
                                                <h6>{userDetails.education.hssc.instName}</h6>
                                                <p>{userDetails.education.hssc.stream}</p>
                                                <p>{userDetails.education.hssc.univ}</p>
                                                <p>{userDetails.education.hssc.state}</p>
                                                <p>Completed in: {userDetails.education.hssc.yop}</p>
                                            </li>
                                            <li className="absoluteContainer">
                                                <h5>SSC</h5>
                                                <h6>{userDetails.education.ssc.instName}</h6>
                                                <p>{userDetails.education.ssc.univ}</p>
                                                <p>{userDetails.education.ssc.state}</p>
                                                <p>Schooling completed in: {userDetails.education.ssc.yop}</p>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className="leftTab">
                                        <h3>Skill Set</h3>
                                        <div className="skillsContainer">
                                            {userDetails.skills ? userDetails.skills.map((item => {
                                                return (

                                                    <span className="badge badge-primary indivSkill">{item}</span>)
                                            })) : null}

                                        </div>
                                    </div>

                                </div>
                            </Col>
                            <Col lg={7} md={12} sm={12} xs={12}>
                                <div className="RightPanelOthers">

                                    <div className="rightTab edu">

                                        <h3>Work Experience</h3>
                                        <ul className="complicatedDiv">
                                            {userDetails.companyDetails ? userDetails.companyDetails.map((item) => {
                                                return (
                                                    <li className="absoluteContainer">
                                                        <h5>{item.name}</h5>
                                                        <h6>{item.role}</h6>
                                                        <p>From: {item.from} To: {item.to}</p>
                                                    </li>
                                                )
                                            }) : null}


                                        </ul>

                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </section>
                    <section className="projects">
                        <Row>
                            <Col>
                                {userDetails.project ?
                                    <div className="tabsOthers">
                                        <h3>Projects and Me</h3>
                                        <ul className="complicatedDiv">
                                            {userDetails.project.map((item) => {
                                                return (<li className="absoluteContainer">
                                                    <h5>{item.name}</h5>
                                                    <p>
                                                        {item.desc}
                                                    </p>
                                                    <a href={item.link} target="_blank" rel="noreferrer noopener">{item.link}</a>
                                                </li>)
                                            })}
                                        </ul>

                                    </div>
                                    : null}







                            </Col>
                        </Row>

                    </section>

                    <footer className="genfooter">
                        <h4>Made with ease using <a href="https://fresume.in" target="_blank" rel="noreferrer noopener"><span>&nbsp;<FaFileAlt className="brandIcon" />Fresume</span></a></h4>
                    </footer>

                </Container>
            </div>
        </div>

    )
}

export default GenHeader;